// extracted by mini-css-extract-plugin
export default {"tos_title":"TosPopup_tos_title__G7t8w","tosContentContainer":"TosPopup_tosContentContainer__qZi23","iframe":"TosPopup_iframe__NuG+g"};